import { EventDetails } from './../tracking/aws-tracker';
import { AwsTrackingService } from './../tracking/aws-tracking.service';
import { DocumentsService } from './../../customer/documents/documents.service';
import { environment } from './../../../environments/environment';
import { Component, OnInit, Input, Output , EventEmitter} from '@angular/core';
import { PartnerDetails } from 'app/application/loan-agreement/insurance-details';

@Component({
  selector: 'zest-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  // public errorMsg = '';
  @Input() errorMsg: string;
  @Input() modalHeader: string;
  @Input() modalContent: any;
  @Input() insurancePartner = new PartnerDetails();
  @Input() insuranceCheck: boolean;
  @Input() insuranceAmount: number;
  @Input() insuranceFeePercentage: number;

  @Output() onClear = new EventEmitter();
  @Output() onConsentCheck = new EventEmitter();
  public s3BucketUrl = environment.s3BucketUrl;
  constructor(private documentsService: DocumentsService, private awsTrackingService: AwsTrackingService) { }
  ngOnInit() {

  }
  closeModal() {
    this.errorMsg = '';
    this.modalHeader = '';
    this.modalContent = '';
    this.onClear.emit();
  }
  downloadFile(fileObj: object) {
    const event1 = new EventDetails(`click_insurance_${this.insurancePartner.partnerName}_${this.insurancePartner.merchantName}_document_download`, 'event', 'triggered', '');
    this.awsTrackingService.sendDataToFunnel(event1).subscribe();
    const url = this.s3BucketUrl + fileObj['fileLocation'];
    const filename = fileObj['fileName'];
    const mimeType = fileObj['fileType'];
    this.documentsService.downloadPdf(url, filename, mimeType);
    const event2 = new EventDetails(`insurance_${this.insurancePartner.partnerName}_${this.insurancePartner.merchantName}_document_downloaded`, 'event', 'triggered', '');
    this.awsTrackingService.sendDataToFunnel(event2).subscribe();
  }
  consentCheck() {
    const msg = (this.insuranceCheck) ? 'optin' : 'optout';
    const event = new EventDetails(`insurance_${this.insurancePartner.partnerName}_${this.insurancePartner.merchantName}_${msg}_modal`.toLowerCase(), 'check', this.insuranceCheck.toString(), 'checkbox');
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
    this.onConsentCheck.emit(this.insuranceCheck);
  }
}
